// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"79":"e36bb712","166":"d5862a9b","675":"331f7dcb","926":"76ceec28"}[chunkId] + ".js";
};